import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Swal from "sweetalert2";
import { useEffect } from "react";
import PaysService from "../../services/PaysService";
import { Link, useNavigate } from "react-router-dom";
import UsersService from "../../services/UsersService";
import AuthService from "../../services/AuthService";
import TypesService from "../../services/TypesService";
import { FiEye, FiEyeOff } from 'react-icons/fi';
import 'react-phone-number-input/style.css';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { myroutes } from "../../routes/webroute"; 
import { useSelector } from "react-redux";





export default function InscriptionParticulier() {

  //Déclaration des champs du formulaire 

  const [nom, setNom] = useState('');
  const [prenoms, setPrenoms] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [adresse, setAdresse] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pays, setPays] = useState([]);
  const [pays_id, setPays_id] = useState('');
  const [type_id, setType_id] = useState(1);
  const [types, setTypes] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [telephoneError, setTelephoneError] = useState('');
  const countPanier = useSelector(state => state.panier.countPanier)



  let navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  
  const handleChange = (value, country) => {
    setTelephone(value);
    setTelephoneError('');
  };

  const [showField, setShowField] = useState(false);

  const handleHideField = () => {
    if (showField) {
      setShowField(false);
    }
  };

  const [rememberMe, setRememberMe] = useState(false);

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  useEffect(() => {
    // Récupérer le libellé du type ayant l'ID 1 depuis le backend
    TypesService.getTypeById(1)
      .then(response => {
        const type = response.data;
        setTypes(type.libelle);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du type:', error);
      });
  }, []);


  useEffect(() => {
    PaysService.index()
      .then(response => {
        if (Array.isArray(response.data.pays)) {
          setPays(response.data.pays);
        } else {
          console.error('La réponse ne contient pas un tableau de pays:', response.data);
        }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des pays:', error);
      });
  }, []);  

  

  

  const register = async (e) => {
  e.preventDefault();
  
  const formData = new FormData();
  formData.append('nom', nom);
  formData.append('prenoms', prenoms);
  formData.append('email', email);
  formData.append('telephone', telephone);
  formData.append('adresse', adresse);
  formData.append('pays_id', pays_id)
  formData.append('type_id', type_id);
  formData.append('password', password);
  formData.append('confirmPassword', confirmPassword); 
  

  // Validation logique ici
  if (password !== confirmPassword) {
    setPasswordError("Les mots de passe ne correspondent pas.");
    return;
  } else {
    setPasswordError("");
  }
  
  if (password.length < 8) {
    setPasswordError("Le mot de passe doit contenir au moins 8 caractères.");
    return;
  } else {
    setPasswordError("");
  }
  
  // Validation du numéro de téléphone
  if (!/^\+?\d*$/.test(telephone)) {
    setTelephoneError('Le numéro de téléphone n\'est pas valide.');
    return;
  }

  if (telephone === '') {
    setTelephoneError('Veuillez saisir votre téléphone');
    return;
  }

    // Sauvegarder les identifiants si "Se rappeler de moi" est coché
    if (rememberMe) {
      localStorage.setItem("email", email);
      localStorage.setItem("password", password);
    } else {
      // Si "Se rappeler de moi" n'est pas coché, supprimez les identifiants sauvegardés
      localStorage.removeItem("email");
      localStorage.removeItem("password");
    }

 await AuthService.register(formData)
  .then(response => {
    Swal.fire({
      icon: 'success',
      title: 'Enregistrement réussi',
      text: response.data.message
    }); 
 

    setNom('');
    setPrenoms('');
    setEmail('');
    setTelephone('');
    setAdresse('');
    setPays_id('');
    setType_id('');
    setPassword('');
    setConfirmPassword(''); 
    
    navigate(myroutes.login);
    
  })
  .catch(error => {
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Vous avez mal renseigné les champs ou cet élément existe déjà dans la base de données'
    });
    console.log(error);
  });
};

useEffect(() => {
  // Vérifier si les identifiants sont sauvegardés dans le stockage local
  const savedEmail = localStorage.getItem("email");
  const savedPassword = localStorage.getItem("password");

  // Remplir automatiquement les champs du formulaire s'ils existent
  if (savedEmail) {
    setEmail(savedEmail);
  }

  if (savedPassword) {
    setPassword(savedPassword);
  }
}, []);

  
    return (
    <React.Fragment>
    <div className="body-page">
<main className="page-center">
  <article className="sign-up">
    <h1 className="sign-up__title" style={{fontFamily:"Arial"}}>Inscription Particulier</h1>
    <p className="sign-up__subtitle mx-auto">Veuillez remplir les champs ci-dessous pour vous inscrire en tant que particulier</p>
    <form className="sign-up-form form" onSubmit={register} >
    <div className="col-md-12 col-sm-12 text-center">
    <Link to={myroutes.homepage}><img src="../startup/img/logo-digiweb.png"  style={{height:"100px"}}/></Link>
        </div>
        <div className="row px-3 mb-4">
             <div className="trait"></div>  
             <div className="text-center">
                ---
             </div>
            
             <div className="trait"></div>
        </div>

        <div className="col-md-12 col-sm-12">
            <div className="row">
            <div className="col-md-6 col-sm-6">
            <label className="form-label-wrapper">
        <p className="form-label" >Nom <i  style={{color:"red"}}>*</i></p>
        <input className="form-control border" style={{ borderRadius: '4px' , marginBottom:"10px",  }} value={nom} onChange={(e) => setNom(e.target.value)} placeholder="Veuillez saisir votre nom"  minlength="3" maxlength="100" required autocomplete="nom" autofocus />
      </label>

            </div>
            <div className="col-md-6 col-sm-6">
            <label className="form-label-wrapper">
             <p className="form-label">Prénoms <i  style={{color:"red"}}>*</i></p>
             <input className="form-control border" style={{ borderRadius: '4px' , marginBottom:"10px" }} type="text" value={prenoms} onChange={(e) => setPrenoms(e.target.value)}  placeholder="Veuillez saisir votre Prénoms"  minlength="3" maxlength="100" required/>
            </label>

            </div>
            </div>
         </div>
        <div className="col-md-12 col-sm-12">
            <div className="row">
            <div className="col-md-6 col-sm-6">
            <label className="form-label-wrapper">
             <p className="form-label">Email<i  style={{color:"red"}}>*</i></p>
             <input className="form-control border" style={{ borderRadius: '4px' , marginBottom:"10px" }} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Veuillez saisir votre email"  minlength="5" maxlength="50" required />
            </label>
            </div>

            <div className="col-md-6 col-sm-6">
            <label className="form-label-wrapper" >
          <p className="form-label">Téléphone <i style={{ color: 'red' }}>*</i></p>
          <PhoneInput
          defaultCountry="bj"
          value={telephone}
          onChange={handleChange}
          inputClass={`form-input ${telephoneError ? 'is-invalid' : ''}`}
          containerStyle={{ border: '1px solid #ccc', borderRadius: '4px' }}
          inputStyle={{ width: '80%', border: 'none', outline: 'none' }}
          placeholder="Numéro de téléphone"
          required
            />
          {telephoneError && (
            <span className="invalid-feedback" role="alert">
              <strong>{telephoneError}</strong>
            </span>
          )}
        </label>

            </div>
            </div>
         </div>
         <div className="col-md-12 col-sm-12">
            <div className="row">
            <div className="col-md-12 col-sm-12">
            <label className="form-label-wrapper">
             <p className="form-label">Adresse <i  style={{color:"red"}}>*</i></p>
             <input className="form-control border" style={{ borderRadius: '4px' , marginBottom:"10px" }} type="text" value={adresse} onChange={(e) => setAdresse(e.target.value)} placeholder="Veuillez saisir votre adresse"  minlength="3" maxlength="100" autoFocus required/>
            </label>
           

            </div>
            <div className="col-md-6 col-sm-6">
              {showField && (
                <label className="form-label-wrapper">
                  <p className="form-label">Profil de l'utilisateur </p>
                  <input className="form-input fw-bold" type="text" value={types} readOnly />
                  <input type="hidden" name="type_id" value={type_id} />
                </label>
              )}
            </div>

            </div>
         </div>
         
      <div className="col-md-12 col-sm-12">
      <label className="form-label-wrapper mb-4">
      <p className="form-label">Pays <i style={{color:"red"}}>*</i></p>
      <select className="form-select" value={pays_id} onChange={(e) => setPays_id(e.target.value)} id="nom_pays" name="nom_pays">
      <option value="">Sélectionnez un pays</option>
              {pays.map(paysItem => (
              <option key={paysItem.id} value={paysItem.id}>{paysItem.nom_pays}</option>
        ))}
      </select>
    </label>
      </div>
        <div className="col-md-12 col-sm-12">
  <div className="row">
    <div className="col-md-5 col-sm-5">
      <label className="form-label-wrapper">
        <p className="form-label">Mot de passe <i  style={{color:"red"}}>*</i></p>
        <input className="form-control border" style={{ borderRadius: '4px' , marginBottom:"10px" }}type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Saisir un mot de passe" minLength={8} maxLength={50} required/>
        <div className="col-lg-12">
          {passwordError && <span className="error-message" style={{color:"red"}}>{passwordError}</span>}
        </div>
      </label>
    </div>
    <div className="form-input col-md-1 col-sm-1" style={{marginTop:"42px", border:"1px solid grey"}}>
      <button type="button" className="password-toggle-button" onClick={togglePasswordVisibility}>
        {showPassword ? <FiEyeOff /> : <FiEye />}
      </button>
    </div>
    <div className="col-md-5 col-sm-5">
      <label className="form-label-wrapper">
        <p className="form-label">Confirmation mot de passe</p>
        <input className="form-control border" style={{ borderRadius: '4px' , marginBottom:"10px" }} type={showConfirmPassword ? 'text' : 'password'} placeholder="Confirmation mot de passe" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        <div className="col-lg-12">
          {confirmPasswordError && <span className="error-message" style={{color:"red"}}>{confirmPasswordError}</span>}
        </div>
      </label>
    </div>
    <div className="form-input col-md-1 col-sm-1" style={{marginTop:"42px", border:"1px solid grey"}}>
      <button type="button" className="password-toggle-button" onClick={toggleConfirmPasswordVisibility}>
        {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
      </button>
    </div>
  </div>
</div>

      <label className="form-checkbox-wrapper">
      <input
        className="form-checkbox"
        type="checkbox"
        checked={rememberMe}
        onChange={handleRememberMeChange}
      />
      <span className="form-checkbox-label">Se rappeler de moi</span>
    </label>

      <div className="col-md-12 col-sm-12">
        <div className="row">
        <div className="col-md-6 col-sm-6">
        <button className="form-btn primary-default-btn transparent-btn fw-bold" type="submit" style={{padding:"3px"}}>S'inscrire</button>
        </div>
        <div className="col-md-6 col-sm-6">
        <Button href="/" variant="dark" className="form-btn primary-default-btn transparent-btn" style={{backgroundColor:"grey", padding:"6px"}}>
                Retour
          </Button>     
        </div>

        </div>
    </div>
    <div className="text-center mt-3 fw-bold">
    <Link className="small" to={myroutes.login} style={{color:"black"}}>Vous avez déjà un compte ? <span style={{color:"blue"}}>Se connecter</span> </Link>
    </div>
    </form>
    
  </article>
</main>
</div>
</React.Fragment>
   
   )
}